import React from 'react'
import { Route, IndexRoute } from 'react-router'
import getPath from '../shared/utils/getPath'
import AdminFormContainer from './containers/AdminForm'
import RootContainer from './containers/Root'
import ListContainer from './containers/List'
import FormContainer from './containers/Form'
import DetailsContainer from './containers/Details'

const guidedTourRoutes = (
  <Route
    component={RootContainer}
    key="guidedTour-routes"
    path={getPath('backend', '/guidedTour')}
  >
    <IndexRoute component={ListContainer} />
    <Route
      path={getPath('backend', '/guidedTour/create')}
      component={FormContainer}
    />
    <Route
      path={getPath('backend', '/guidedTour/:id')}
      component={DetailsContainer}
    />
    <Route
      path={getPath('backend', '/guidedTour/:id/edit')}
      component={FormContainer}
    />
    <Route
      path={getPath('backend', '/guidedTour/:id/admin')}
      component={AdminFormContainer}
    />
  </Route>
)

export default guidedTourRoutes



// WEBPACK FOOTER //
// ./src/guided-tour/routes.js